import { render, staticRenderFns } from "./JanusCall.vue?vue&type=template&id=0e298cb2&lang=pug&"
import script from "./JanusCall.vue?vue&type=script&lang=js&"
export * from "./JanusCall.vue?vue&type=script&lang=js&"
import style0 from "./JanusCall.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports